import {SaleTypeVo} from '../../common/shared/api/nicolas/vo/SaleTypeVo.enum';
import {SaleType} from '../generated/types';

export function createSaleType(saleTypeVo: SaleTypeVo): SaleType {
  return SaleTypeMap[saleTypeVo];
}

const SaleTypeMap: {[key in SaleTypeVo]: SaleType} = {
  [SaleTypeVo.Sale]: SaleType.Sale,
  [SaleTypeVo.Refund]: SaleType.Refund,
};
